import React from "react";
import { ReactComponent as EllipsisRegularIcon } from "../../../assets/icons/ellipsis-regular.svg";
import { ReactComponent as SearchRegularIcon } from "../../../assets/icons/search-regular.svg";
import TooltipComponent from "../../common/tooltip-component";
import { TSearchInputProps } from "../../common/util-components/autosuggest/autosuggest";

export type TBillingServiceSearchInputProps = TSearchInputProps & {
  multipleServiceNames?: string;
  placeholder?: string;
};

const BillingServiceSearchInput = ({
  isDisabled = false,
  isInputActive,
  inputValue,
  handleFocus = () => {},
  handleBlur = () => {},
  handleValueChange,
  handleInputKeyDown = () => {},
  multipleServiceNames,
  placeholder,
}: TBillingServiceSearchInputProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (!isInputActive) {
      inputRef.current?.blur();
    }
    if (isInputActive) {
      inputRef.current?.select();
    }
  }, [isInputActive]);

  const handleInputChange = async (value: string) => {
    handleValueChange(value);
  };

  const handleInputFieldWrapperClick = () => {
    if (!isInputActive && !isDisabled) {
      handleFocus();
      inputRef.current?.focus();
    }
  };

  if (!!multipleServiceNames) {
    return (
      <div className="flex items-center px-8 py-7 space-x-4 w-full border rounded-2 border-darwin-neutral-100 bg-darwin-neutral-50 cursor-not-allowed	">
        <EllipsisRegularIcon className="w-16 h-16 text-darwin-neutral-400" />
        <TooltipComponent title={multipleServiceNames}>
          <div className="w-full flex-grow text-13 font-400 leading-5 focus:outline-none text-darwin-neutral-600">
            Multiple
          </div>
        </TooltipComponent>
      </div>
    );
  }

  return (
    <div
      className={`flex items-center px-8 py-7 space-x-4 w-full border rounded-2 ${
        isInputActive
          ? "border-darwin-primary-500"
          : "border-darwin-neutral-100"
      } ${
        isDisabled
          ? "bg-darwin-neutral-50 cursor-not-allowed"
          : "bg-neutral-0 cursor-text"
      }`}
      onClick={handleInputFieldWrapperClick}
    >
      <SearchRegularIcon className="w-16 h-16 text-darwin-neutral-400" />
      <input
        ref={inputRef}
        value={inputValue}
        onChange={(e) => handleInputChange(e.target.value)}
        className={`w-full flex-grow text-13 font-400 leading-5 focus:outline-none bg-inherit placeholder-darwin-neutral-600 capitalize ${
          isDisabled
            ? "text-darwin-neutral-600 cursor-not-allowed"
            : "text-darwin-neutral-1000"
        }`}
        placeholder={!!placeholder ? placeholder : "Select A Service"}
        onClick={handleFocus}
        onBlur={handleBlur}
        disabled={isDisabled}
        onKeyDown={handleInputKeyDown}
      />
    </div>
  );
};

export default BillingServiceSearchInput;
